import { EpimsBaseEntityDto } from './epim-base.dto';
export class StakeholderGroupDto extends EpimsBaseEntityDto {

    StakeholderGroupId: string;

    StakeholderGroupName: string;

   

}